import "./VideoPlayer.scss";

import { ComponentProps, FC } from "react";
import ReactPlayer from "react-player";

type ReactPlayerProps = ComponentProps<typeof ReactPlayer>;

interface IProps {
  url: string;
  options?: Omit<ReactPlayerProps, "src">;
}

const VideoPlayer: FC<IProps> = ({ url, options = {} }) => {
  const videoPlayerProps = {
    controls: true,
    width: "100%",
    height: "100%",
    ...options,
  };

  return (
    <div className="video-player__container">
      <ReactPlayer className="video-player" src={url} {...videoPlayerProps} />
    </div>
  );
};

export default VideoPlayer;
